package site.shadadman.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initVideosPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Videos.md", FrontMatterElement.Builder { addScalar("title", "Videos"); }))
}

@Page("/videos")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun VideosPage() {
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" I created these videos on my free time. Some might not be perfect in quality. Most of them where published on LinkedIn.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.linkedin.com/feed/update/urn:li:activity:7426542892862734336/") {
            org.jetbrains.compose.web.dom.Text("Create a replica of human jaw")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.linkedin.com/feed/update/urn:li:activity:7325103931762642944/") {
            org.jetbrains.compose.web.dom.Text("KMP + Hugging Face LLM")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.linkedin.com/feed/update/urn:li:activity:7317490871057145858/") {
            org.jetbrains.compose.web.dom.Text("KMP; Where frontend and backend shake hands")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.linkedin.com/feed/update/urn:li:activity:7315346569610821633/") {
            org.jetbrains.compose.web.dom.Text("Thing you did not know about KMP")
        }
    }
}
